"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteConfirmationCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const commands_1 = require("../../survey/commands");
const commands_2 = require("../commands");
const CardHelper_1 = require("../utils/CardHelper");
const SimpleImageCard_1 = require("./SimpleImageCard");
const DeleteConfirmationCard = (series, survey, applicationType) => {
    let message;
    if (series && survey) {
        message = `Would you like to delete the current instance or the entire series?`;
    }
    else if (series) {
        message = series.message || `Would you like to delete the entire series?`;
    }
    else {
        message = survey.message || `Would you like to delete the instance?`;
    }
    const card = (0, SimpleImageCard_1.SimpleImageCard)(`This will erase all related data. ${message}`, "WARN", applicationType, "Cancel");
    if (series) {
        card.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
            title: series.label || "Delete Series",
            isPrimary: !survey,
            data: (0, commands_2.scheduleDeleteCommand)({ scheduleId: series.id }).toTaskFetchCommand(),
        }));
    }
    if (survey) {
        card.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
            title: survey.label || "Delete Instance",
            isPrimary: true,
            data: (0, commands_1.SurveyDeleteCommand)(survey.id).toTaskFetchCommand(),
        }));
    }
    return card;
};
exports.DeleteConfirmationCard = DeleteConfirmationCard;
//# sourceMappingURL=DeleteConfirmationCard.js.map